const REFERENCE_LINKS = [
  { id: "grammar", label: "Filter grammar", href: "#grammar" },
  { id: "types", label: "Data types", href: "#types" },
  { id: "errors", label: "Errors", href: "#errors" },
  { id: "schema", label: "OpenAPI schema", href: "/api/schema/?format=json", external: true },
];

function ExternalIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M11 4H4v12h12v-7" /><path d="M10 10l6-6" /><path d="M11 4h5v5" />
    </svg>
  );
}

/**
 * Sticky left rail. The catalog items indent one level each because an observatory
 * contains instruments, which produce datasets; the hairline "chain rule" between them
 * draws that containment.
 */
export function ApiNavRail({ groups, activeId, onSelect }) {
  return (
    <nav className="apiNavRail" aria-label="API resources">
      {groups.map((group) => (
        <div className="apiNavGroup" key={group.id}>
          <div className="apiNavGroupLabel">{group.label}</div>
          {group.resources.map((r, i) => {
            const active = r.id === activeId;
            const indent = group.id === "catalog" && i > 0 ? ` apiNavIndent${i}` : "";
            return (
              <div key={r.id}>
                {group.id === "catalog" && i > 0 && <div className="apiNavChainRule" aria-hidden="true" />}
                <a
                  className={(active ? "apiNavItem apiNavItemActive" : "apiNavItem") + indent}
                  href={`#${r.id}`}
                  aria-current={active ? "page" : undefined}
                  onClick={(e) => { e.preventDefault(); onSelect(r.id); }}
                >
                  <span>{r.label}</span>
                </a>
              </div>
            );
          })}
        </div>
      ))}
      <div className="apiNavGroup">
        <div className="apiNavGroupLabel">Reference</div>
        {REFERENCE_LINKS.map((l) => (
          <a
            className="apiNavItem"
            key={l.id}
            href={l.href}
            target={l.external ? "_blank" : undefined}
            rel={l.external ? "noreferrer" : undefined}
          >
            <span>{l.label}</span>
            {l.external && <ExternalIcon />}
          </a>
        ))}
      </div>
    </nav>
  );
}
